import { Link } from 'react-router-dom';

import { LogoutOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import eduzzAccountsService from 'v2/services/eduzzAccount';

const Header = () => {
  return (
    <header className='eduzz-ui-layout-topbar-header px-8 py-3'>
      <div className='flex items-center justify-between'>
        <Link to='/'>
          <img className='h-full w-40' alt='MyEduzz' src='https://cdn.eduzzcdn.com/topbar/myeduzz.svg' />
        </Link>
        <Button onClick={() => eduzzAccountsService.logout()} icon={<LogoutOutlined />}>
          Sair
        </Button>
      </div>
    </header>
  );
};

export default Header;
